<template>
  <div class="news_card">
    <div class="img" :style="{ backgroundImage: `url(${img})`}"></div>
    <div class="title">{{title}}</div>
    <div v-if="teach" class="teach">
      <div class="date">
        <i class="icon icon-calendar"></i>
        {{date}}
      </div>
      <div class="place">
        <i class="icon icon-place"></i>
        {{place}}
      </div>
      <div class="contribute">
        <i class="icon icon-pen"></i>
        投稿時間： {{contribute}}
      </div>
    </div>
    <div v-else class="intro">{{intro}}</div>
  </div>
</template>
<script>
export default {
  name: "NewsCard",
  components: {},
  props: ["img", "title", "date", "place", "contribute", "intro", "teach"]
};
</script>
<style scoped>
.news_card {
  padding-bottom: 50px;
  border-bottom: 1px solid #989898;
}
.news_card .img {
  width: 100%;
  padding-bottom: 60%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.news_card .title {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 3.5rem;
  font-size: 1.25rem;
}
.news_card .intro,
.news_card .teach {
  height: 97px;
  margin-bottom: 10px;
}
.news_card .teach > div {
  margin: 5px 0;
}
.news_card .teach .icon {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/index/NewsCard.vue